function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSantaclaus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x34_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1.431,245.956c0,145.297,106.494,263.075,237.862,263.075 c131.371,0,237.865-117.779,237.865-263.075c0-10.95-0.674-21.719-1.851-32.326H3.279C2.109,224.237,1.431,235.006,1.431,245.956z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8DCAC"
    },
    d: "M1.855,208.638C0.678,218.223,0,227.963,0,237.865c0,90.317,50.337,168.878,124.49,209.161 l238.385-238.388H1.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8CBA0"
    },
    d: "M362.875,208.638L124.49,447.026c33.701,18.307,72.325,28.708,113.375,28.708 c131.37,0,237.865-106.498,237.865-237.869c0-9.902-0.674-19.642-1.852-29.227H362.875z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D61630"
    },
    d: "M237.865,0C141.818,0,59.126,56.96,21.57,138.919h432.597C416.615,56.96,333.918,0,237.865,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M21.57,138.919c-9.939,21.686-16.703,45.117-19.715,69.719h472.024 c-3.015-24.602-9.773-48.033-19.712-69.719H21.57z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M347.95,366.185c-22.02-42.168-73.392-55.582-110.085-55.582 c-36.686,0-88.066,13.414-110.088,55.582c0,0-24.192,33.006-22.377,74.837c37.86,26.569,83.427,42.085,132.465,42.085 c49.045,0,94.605-15.516,132.462-42.085C372.145,399.191,347.95,366.185,347.95,366.185z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M0,238.302c0,83.718,41.999,157.461,105.767,200.762c6.169-7.062,9.948-16.336,9.948-26.523 c0-22.029-17.539-39.893-39.219-40.022c1.607-4.358,2.526-9.053,2.526-13.979c0-16.842-10.26-31.231-24.774-37.142 c2.922-5.591,4.589-11.953,4.589-18.72c0-15.179-8.318-28.378-20.581-35.165c7.042-7.234,11.41-17.173,11.41-28.15 c0-12.342-5.511-23.378-14.174-30.725H1.855C0.678,218.366,0,228.251,0,238.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M475.731,238.302c0,83.718-41.996,157.461-105.761,200.762 c-6.176-7.062-9.958-16.336-9.958-26.523c0-22.029,17.543-39.893,39.226-40.022c-1.607-4.358-2.526-9.053-2.526-13.979 c0-16.842,10.262-31.231,24.776-37.142c-2.922-5.591-4.596-11.953-4.596-18.72c0-15.179,8.318-28.378,20.585-35.165 c-7.049-7.234-11.414-17.173-11.414-28.15c0-12.342,5.515-23.378,14.184-30.725h33.631 C475.056,218.366,475.731,228.251,475.731,238.302z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C7DB"
    },
    d: "M282.817,314.138c0,24.827-20.121,44.952-44.951,44.952c-24.823,0-44.952-20.125-44.952-44.952 c0-24.827,20.129-44.952,44.952-44.952C262.695,269.186,282.817,289.311,282.817,314.138z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6E6049"
    },
    cx: 161.031,
    cy: 262.768,
    r: 17.202
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E6049"
    },
    d: "M331.902,262.768c0,9.499-7.697,17.199-17.199,17.199c-9.502,0-17.199-7.7-17.199-17.199 c0-9.499,7.697-17.203,17.199-17.203C324.204,245.566,331.902,253.269,331.902,262.768z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AF1D35"
    },
    points: "424.305,138 312.382,73.783 278.069,138  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.4,
      fill: "#231815"
    },
    cx: 437.695,
    cy: 133.818,
    r: 55.962
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M512,122.811c0,30.907-25.048,55.959-55.961,55.959c-30.907,0-55.962-25.052-55.962-55.959 c0-30.903,25.055-55.958,55.962-55.958C486.952,66.853,512,91.908,512,122.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.19,
      fill: "#231815"
    },
    d: "M0.364,250.84h475.004c0.231-4.298,0.363-8.62,0.363-12.974 c0-9.902-0.674-19.642-1.852-29.227H1.855C0.678,218.223,0,227.963,0,237.865C0,242.22,0.135,246.541,0.364,250.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantaclaus);
export default __webpack_public_path__ + "static/media/santaclaus.2faabbc502d439cc23111cb165e39695.svg";
export { ForwardRef as ReactComponent };